module.exports = __webpack_public_path__ + "static/10-e95052671b97def8889a21ffcb9ea26d.png";